import ICommand from '../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../FrontApplet/FrontApplet';
import { HtmlSnapshotTaken, TakeHtmlSnapshot } from './htmlCommands';

export function handleHtmlSnapshotTakingRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<TakeHtmlSnapshot>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<TakeHtmlSnapshot>) => {
		switch (commandEvent.command.type) {
			case TakeHtmlSnapshot:
				await dispatch<HtmlSnapshotTaken>({
					type: HtmlSnapshotTaken,
					html: frontApplet.window.document.documentElement.outerHTML,
				});
				break;
			default:
		}
	});
}
